import { useState, useEffect } from 'react';
import api from '../services/api';

function Modal({ tienda, onClose, onSave }) {
  const [form, setForm] = useState(tienda || { name:'', address:'', city:'', lat:'', lng:'', radius:200, active:true });
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await onSave(form); onClose(); }
    catch { /* error handled by parent */ }
    finally { setLoading(false); }
  };

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.modal} onClick={e => e.stopPropagation()}>
        <div style={s.modalHead}>
          <span style={s.modalTitle}>{tienda ? 'Editar tienda' : 'Nueva tienda'}</span>
          <button onClick={onClose} style={s.closeBtn}>✕</button>
        </div>
        <form onSubmit={handle} style={{ padding:24 }}>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
            <div style={{ gridColumn:'1/-1' }}>
              <label style={s.label}>Nombre de la tienda</label>
              <input style={s.input} required value={form.name} onChange={e => setForm({...form, name:e.target.value})} placeholder="Sucursal Centro" />
            </div>
            <div style={{ gridColumn:'1/-1' }}>
              <label style={s.label}>Dirección</label>
              <input style={s.input} value={form.address} onChange={e => setForm({...form, address:e.target.value})} placeholder="Av. Principal #123" />
            </div>
            <div>
              <label style={s.label}>Ciudad</label>
              <input style={s.input} value={form.city} onChange={e => setForm({...form, city:e.target.value})} placeholder="Chihuahua" />
            </div>
            <div>
              <label style={s.label}>Radio geofencing (m)</label>
              <input style={s.input} type="number" min={50} max={1000} value={form.radius} onChange={e => setForm({...form, radius:parseInt(e.target.value)})} />
            </div>
            <div>
              <label style={s.label}>Latitud</label>
              <input style={s.input} type="number" step="any" value={form.lat} onChange={e => setForm({...form, lat:e.target.value})} placeholder="28.6325" />
            </div>
            <div>
              <label style={s.label}>Longitud</label>
              <input style={s.input} type="number" step="any" value={form.lng} onChange={e => setForm({...form, lng:e.target.value})} placeholder="-106.0691" />
            </div>
          </div>
          <div style={{ marginTop:16, display:'flex', alignItems:'center', gap:10 }}>
            <input type="checkbox" id="active" checked={form.active} onChange={e => setForm({...form, active:e.target.checked})} />
            <label htmlFor="active" style={{ fontSize:13, color:'#555' }}>Tienda activa</label>
          </div>
          <div style={{ marginTop:24, display:'flex', gap:10 }}>
            <button type="submit" style={s.btnPrimary} disabled={loading}>{loading ? 'Guardando...' : 'Guardar tienda'}</button>
            <button type="button" onClick={onClose} style={s.btnSec}>Cancelar</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default function Tiendas() {
  const [tiendas, setTiendas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const load = async () => {
    setLoading(true);
    try { const res = await api.get('/api/stores'); setTiendas(res.data.data || []); }
    catch { setTiendas([]); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const save = async (form) => {
    if (form.id) await api.put(`/api/stores/${form.id}`, form);
    else await api.post('/api/stores', form);
    load();
  };

  return (
    <div>
      <div style={s.header}>
        <div>
          <h1 style={s.title}>Tiendas</h1>
          <p style={s.sub}>Administra sucursales y geofencing para notificaciones por ubicación</p>
        </div>
        <button style={s.btnPrimary} onClick={() => { setSelected(null); setShowModal(true); }}>+ Nueva tienda</button>
      </div>

      <div style={s.infoBox}>
        El geofencing permite enviar una notificación push automática cuando un cliente con el wallet pass se encuentra a menos de X metros de la tienda. Requiere que el cliente tenga instalado el pass y los servicios de ubicación activados.
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(300px,1fr))', gap:16, marginTop:24 }}>
        {loading ? <p style={{ color:'#aaa' }}>Cargando...</p>
        : tiendas.length === 0 ? (
          <div style={s.emptyCard}>
            <div style={{ fontSize:32, marginBottom:12 }}>—</div>
            <p style={{ color:'#888', fontSize:14 }}>No hay tiendas configuradas</p>
            <button style={{...s.btnPrimary, marginTop:16}} onClick={() => setShowModal(true)}>Agregar primera tienda</button>
          </div>
        ) : tiendas.map(t => (
          <div key={t.id} style={s.storeCard}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:12 }}>
              <div>
                <div style={{ fontSize:15, fontWeight:600, color:'#111' }}>{t.name}</div>
                <div style={{ fontSize:12, color:'#888', marginTop:2 }}>{t.city}</div>
              </div>
              <span style={{ ...s.badge, background:t.active?'#f0fdf4':'#f5f5f5', color:t.active?'#166534':'#888' }}>
                {t.active ? 'Activa' : 'Inactiva'}
              </span>
            </div>
            {t.address && <div style={{ fontSize:13, color:'#666', marginBottom:8 }}>{t.address}</div>}
            <div style={{ fontSize:12, color:'#aaa', display:'flex', gap:16 }}>
              {t.lat && <span>Lat: {parseFloat(t.lat).toFixed(4)}</span>}
              {t.lng && <span>Lng: {parseFloat(t.lng).toFixed(4)}</span>}
              <span>Radio: {t.radius}m</span>
            </div>
            <button onClick={() => { setSelected(t); setShowModal(true); }} style={{...s.btnSec, marginTop:12, fontSize:11}}>Editar</button>
          </div>
        ))}
      </div>

      {showModal && <Modal tienda={selected} onClose={() => setShowModal(false)} onSave={save} />}
    </div>
  );
}

const s = {
  header: { display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:20 },
  title: { fontSize:24, fontWeight:700, margin:'0 0 4px', color:'#111', fontFamily:"'Barlow Condensed',sans-serif", textTransform:'uppercase', letterSpacing:-0.5 },
  sub: { fontSize:13, color:'#888', margin:0 },
  infoBox: { background:'#fafafa', border:'1px solid #eee', padding:16, fontSize:13, color:'#666', lineHeight:1.6 },
  storeCard: { background:'#fff', border:'1px solid #eee', padding:20 },
  emptyCard: { background:'#fff', border:'1px solid #eee', padding:40, textAlign:'center', gridColumn:'1/-1' },
  badge: { padding:'3px 10px', fontSize:11, fontWeight:600, textTransform:'uppercase', letterSpacing:1 },
  btnPrimary: { background:'#111', color:'#fff', border:'none', padding:'10px 20px', fontSize:12, fontWeight:600, letterSpacing:2, textTransform:'uppercase', cursor:'pointer', fontFamily:"'Barlow',sans-serif" },
  btnSec: { background:'#f5f5f5', color:'#333', border:'none', padding:'10px 20px', fontSize:12, fontWeight:600, letterSpacing:1, textTransform:'uppercase', cursor:'pointer', fontFamily:"'Barlow',sans-serif" },
  overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:200 },
  modal: { background:'#fff', width:'100%', maxWidth:520 },
  modalHead: { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'20px 24px', borderBottom:'1px solid #eee' },
  modalTitle: { fontSize:13, fontWeight:600, letterSpacing:2, textTransform:'uppercase' },
  closeBtn: { background:'none', border:'none', cursor:'pointer', fontSize:16, color:'#888' },
  label: { display:'block', fontSize:11, fontWeight:600, letterSpacing:2, textTransform:'uppercase', color:'#555', marginBottom:6 },
  input: { width:'100%', padding:'10px 14px', border:'1.5px solid #e5e5e5', fontSize:14, outline:'none', boxSizing:'border-box', fontFamily:"'Barlow',sans-serif", borderRadius:0 },
};
